<template>
    <!-- 订单详情 -->
    <div  class="Booking">
        <div class="jindutiao">
            <div class="title">订单状态</div>
            <el-steps :active="form.order_status"  v-if="form.order_status!=4" >
                <el-step icon="el-icon-success" title="已下单" :description="form.create_time"></el-step>
                <el-step icon="el-icon-success" title="处理中" :description="form.two_status_time"></el-step>
                <el-step icon="el-icon-success" title="已完成" :description="form.three_status_time"></el-step>
            </el-steps>
            <div class="quxiaodd" v-if="form.order_status==4" :active="form.order_status">
                <el-steps align-center :active="form.order_status" >
                    <el-step icon="el-icon-error" title="用户取消订单" :description="form.four_status_time"></el-step>
                </el-steps>
            </div>
        </div>
        <div class="contenmt">
            <!-- 订单信息 -->
            <div>
                <div class="con-tit">
                    订单信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            订单编号
                        </div>
                        <div class="nr-c">
                            {{form.order_sn}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            订单类型
                        </div>
                        <div class="nr-c">
                            船东SPOT
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            下单时间
                        </div>
                        <div class="nr-c">
                            {{form.create_time}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 基本信息 -->
            <div>
                <div class="con-tit">
                    基本信息
                </div>
                <div class="neirong">
                    <div class="nr ">
                        <div class="nr-t">
                            起运港
                        </div>
                        <div class="nr-c">
                            {{form.pol_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            目的港
                        </div>
                        <div class="nr-c">
                            {{form.pod_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            中转/直达
                        </div>
                        <div class="nr-c">
                            {{form.is_transit == 1?'中转':'直达'}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            ETA
                        </div>
                        <div class="nr-c">
                            {{form.eta}}

                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            ETD
                        </div>
                        <div class="nr-c">
                            {{form.etd}}

                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            船期
                        </div>
                        <div class="nr-c">
                            {{form.shipping_date}}天
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            航名
                        </div>
                        <div class="nr-c">
                            {{form.vessel || '--'}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            航次
                        </div>
                        <div class="nr-c">
                            {{form.voyage || '--'}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            运输条款
                        </div>
                        <div class="nr-c">
                            {{form.transportation_terms}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            保证金
                        </div>
                        <div class="nr-c dongjie">
                            CNY 
                            {{form.dead_freight}}

                            <span v-if="form.dead_freight_status==1">冻结中</span>
                            <span v-if="form.dead_freight_status==2">已解冻</span>
                            <span v-if="form.dead_freight_status==3">已扣款</span>
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            保证金扣除金额
                        </div>
                        <div class="nr-c dongjie">
                            CNY 
                            {{form.dead_freight_deduct}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            服务费
                        </div>
                        <div class="nr-c dongjie">
                            CNY 
                            {{form.service_charge}}
                        </div>
                    </div>
                </div>
            </div>


            <!-- 集装箱信息 -->
            <div>
                <div class="con-tit">
                    集装箱信息
                </div>
                <el-table
                    :data="form.base_price"
                    style="width: 100%"
                    :header-cell-style="{ background: '#f9f9f9' }"
                >
                    <el-table-column prop="box_type" label="箱型"> </el-table-column>
                    <el-table-column prop="number" label="箱量"> </el-table-column>
                    <el-table-column prop="total_price" label="金额">
                        <template slot-scope="scope">
                            {{scope.row.currency}} {{scope.row.total_price}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="dead_freight" label="保证金">
                        <template slot-scope="scope">
                            {{spot_dead_freight * scope.row.number}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div>
                <div class="con-tit">
                    订舱账号
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            船司账号
                        </div>
                        <div class="nr-c">
                            {{form.booking_account == 2 ? '第三方账号' : form.account }}
                        </div>
                    </div>
                    <!-- <div class="nr">
                        <div class="nr-t">
                            船司账号
                        </div>
                        <div class="nr-c">
                            {{form.account}}
                        </div>
                    </div> -->
                </div>
            </div>

            <!-- 货物信息 -->
            <div v-if="form.booking_account == 2">
                <div class="con-tit">
                    货物信息
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            包装单位
                        </div>
                        <div class="nr-c">
                            {{form.packing_unit}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            件数
                        </div>
                        <div class="nr-c">
                            {{form.quantity}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            总重量(kgs)
                        </div>
                        <div class="nr-c">
                            {{form.totle_weight}}
                        </div>
                    </div>
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            体积(cbm)
                        </div>
                        <div class="nr-c">
                            {{form.totle_volume}}
                        </div>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            唛头
                        </div>
                        <!-- <div class="nr-c nr-cer">
                            {{form.shipping_mark}}
                        </div> -->
                        <el-input readonly  type="textarea" v-model="form.shipping_mark"></el-input>
                    </div>
                    <div class="nr nryi xiaoInput">
                        <div class="nr-t">
                            货物描述
                        </div>
                        <!-- <p class="nr-c nr-cer">
                            {{form.describe}}
                        </p> -->
                        <el-input readonly type="textarea" v-model="form.describe"></el-input>
                    </div>
                </div>
            </div>
            <!-- 订舱联系人 -->
            <div v-if="form.booking_account == 2">
                <div class="con-tit">
                    订舱联系人
                </div>
                <div class="neirong yxnr">
                    <div class="nr">
                        <div class="nr-t">
                            订舱联系人
                        </div>
                        <div class="nr-c">
                            {{form.linkman}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            联系人电话
                        </div>
                        <div class="nr-c">
                            {{form.linkman_phone}}
                        </div>
                    </div>
                    <div class="nr"
                    v-for="(item,index) in form.email"
                    :key="index"
                    :class="{'nryi' : (index+2)%3 != 0 }">
                        <div class="nr-t">
                            联系人邮箱
                        </div>
                        <div class="nr-c">
                            {{item}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 自有账号信息 -->
            <div v-if="form.booking_account == 1">
                <div class="con-tit">
                    自有账号
                </div>
                <div class="neirong">
                    <div class="nr">
                        <div class="nr-t">
                            自有账号的企业名称
                        </div>
                        <div class="nr-c">
                            {{form.enterprise_name}}
                        </div>
                    </div>
                    <div class="nr nryi">
                        <div class="nr-t">
                            自有账号的账号
                        </div>
                        <div class="nr-c">
                            {{form.account}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 订单备注 -->
            <div>
                <div class="con-tit">
                    订单备注
                </div>
                <div class="neirong">
                    <div class="nr daInput">
                        <div class="nr-t">
                            备注内容
                        </div>
                        <!-- <p class="nr-c nr-csan">
                            {{form.remarks}}
                        </p> -->
                        <el-input readonly  type="textarea" v-model="form.remarks"></el-input>
                    </div>
                </div>
            </div>

            <div class="btnss">
                <el-button class="quxoia" v-if="form.order_status!=4"  @click="dialogFormVisible = true">取消订单</el-button>
                <!-- <el-button class="yulan">预览</el-button> -->
                <el-button class="daochu" @click="daochu">导出</el-button>
            </div>
        </div>
         <!-- 取消订单原因 -->
         <el-dialog title="订单取消" :visible.sync="dialogFormVisible">
            <el-form :model="cancelForm">
                <el-form-item label="取消原因" >
                <el-input
                    type="textarea"
                    placeholder="请输入"
                    v-model="cancelForm.cancel_reason">
                </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary"  @click="cancellation">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import { shipOrderDetail,shipCancelOrder,createOrderInfo,config } from "@/api/api";
export default {
    components:{
        
    },
    data() {
        return {
            active: 1,
            headers:{
                token: localStorage.getItem('token')
            },
            form:{},
            dialogFormVisible:false,
            cancelForm:{
                order_id:'',
                cancel_reason:''
            },
            spot_dead_freight:0,
        }
    },
    methods: {
            // 取消订单
            async cancellation(){
            if (this.cancelForm.cancel_reason.trim()==''){
                this.$message({
                type:'error',
                message:'取消原因不能为空'
                })
            }else{
                try {
                    this.cancelForm.order_id=this.$route.query.id
                    const res = await shipCancelOrder(this.cancelForm,this.headers)
                    if(res.code==1){
                        this.$message({
                            type:'success',
                            message:'订单取消成功'
                        })
                        this.dialogFormVisible = false
                        this.form.order_status=4
                        this.$router.push('/Order')
                    }else{
                    this.$message({
                        type:'error',
                        message:res.message
                    })
                    }
                } catch (error) {
                    console.log(error,'失败');
                }
            }
        },
        async getDetails(){
            try {
                const res = await shipOrderDetail({
                    order_id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.form = res.data
                    // this.form.shipping_mark = this.form.shipping_mark+this.form.shipping_mark+this.form.shipping_mark
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        async daochu(){
            try {
                const res = await createOrderInfo({
                    order_id: this.$route.query.id
                },this.headers)
                if(res.code==1){
                    // this.form = res.data
                    this.$message({
                        type:'success',
                        message:'导出成功'
                    })
                    const link = document.createElement('a');
                    link.href = res.data.url;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }else{
                    this.$message({
                        type:'error',
                        message:'导出失败'
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        async getconfig(){
            try {
                const res = await config(this.headers)
                this.spot_dead_freight = res.data.spot_dead_freight
            } catch (error) {
                console.log(error,'失败');
            }
        },
    },
    mounted(){
        this.getDetails()
        this.getconfig()
    }
}
</script>
    
<style style lang="scss" scoped>
.Booking{
    background: pink;
}

.jindutiao{
    width: 1136px;
    height: 180px;
    background: #F9F9F9;
    border-radius: 0px 0px 0px 0px;

    .quxiaodd{
    text-align: center;
    .kehu{
      font-size: 16px;
      color: #999999;
    }
    .shijian{
      font-size: 14px;
      color: #999999;
    }

    .el-icon-error{
      color: #0073F5;
      font-size: 20px;
      margin: 8px 0px;
    }
  }
    .title{
        padding-top: 24px;
        padding-left: 24px;
        padding-bottom: 20px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .el-steps{
        padding: 0 60px;
        justify-content: center;
    }
    :deep(.el-steps){
        .el-step__icon{
            background: #F9F9F9;
        }
    }
}

.xiaoInput{
    :deep(.el-textarea){
        width: 260px;
        background: #F9F9F9;
        border-radius: 9px 9px 9px 9px;
        .el-textarea__inner {
            width: 260px;
            height: 120px;
            background: #F9F9F9;
            border: 0;
        }
    }
}

.daInput{
    :deep(.el-textarea){
        width: 1044px;
        background: #F9F9F9;
        border-radius: 9px 9px 9px 9px;
        .el-textarea__inner {
            width: 1044px;
            height: 200px;
            background: #F9F9F9;
            border: 0;
        }
    }
}

.contenmt{
    background: #fff;
    padding: 20px;

    .con-tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        padding-top: 12px;
        padding-bottom: 24px;

    }

    .neirong{
        display: flex;
        margin-bottom: 20px;
        .nr{
            display: flex;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            font-style: normal;
            text-transform: none;
        }

        .nryi{
          margin-left: 30px;  
        }


        .nr-t{
            width: 85px;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #606260;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-top: 10px;
        }

        .nr-c{
            width: 260px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 9px 9px 9px 9px;
            
            padding: 10px 12px;

            box-sizing: border-box;

            
        }

        .nr-cer{
            height: 120px;
            margin: 0;
            overflow:hidden;
            display: -webkit-box;  
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis; 

        }

        .nr-csan{
            width: 1044px;
            height: 200px;
            margin: 0;
        }

        .chakan{
            text-align: center;

            cursor: pointer;

            color: #0073F5;
        }

        .dongjie{
            display: flex;
            align-items: center;
            span{
                display: inline-block;

                width: 48px;
                height: 20px;
                background: #EDF6FF;
                border-radius: 4px 4px 4px 4px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 10px;
                color: #0073F5;
                line-height: 20px;
                text-align: center;
                font-style: normal;
                text-transform: none;

                margin-left: 8px;
            }
        }

        .con-up{
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                display: flex;
                align-items: center;
            }
            i{
                font-size: 16px;
                color: #00b53c;
                margin-right: 9px;
            }

            .name{
                width: 130px;

                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #333333;
                font-style: normal;
                text-transform: none;
            }

            .el-butnm{
                color: #0073F5;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                font-style: normal;
                text-transform: none;

                height: 18px;
                padding: 0;
            }
        }
    }

    .yxnr{
        flex-wrap: wrap;
        .nr{
            margin-bottom: 16px;
        }
    }
}

.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-bottom: 20px;
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }
}

.btnss{
    text-align: center;
    margin-top: 48px;
    .el-button{
        width: 100px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        border: 0;
        font-size: 14px;
    }

    .quxiao{
        background: #F9F9F9;
        color: #999999;
    }

    .yulan{
        color: #0073F5;
        border: 1px solid #0073F5;
        background: #fff;
    }

    .daochu{
        background: #0073F5;
        color: #fff;
    }
}
</style>